import { Component, ComponentRef, Type, ViewChild, ViewContainerRef } from '@angular/core';

import { Modal } from '../../models/modal.model';

@Component({
    templateUrl: './modal-container.component.html',
    styleUrls: ['./modal-container.component.scss'],
    standalone: false
})
export class ModalContainerComponent {
  @ViewChild('modalContainer', { read: ViewContainerRef, static: true }) private modalContainer: ViewContainerRef;

  public size: string = 'small';
  public options: { noBg: boolean; headerHeight: 'normal' | 'small'; rounded: 'normal' | 'small'; keepOpen: boolean } = {
    noBg: false,
    headerHeight: 'normal',
    rounded: 'normal',
    keepOpen: false
  };

  createModal<T extends Modal>(component: Type<T>): ComponentRef<T> {
    this.modalContainer.clear();
    return this.modalContainer.createComponent(component);
  }
}
